module.exports = __webpack_public_path__ + "static/media/background-banner.d6417343.png";